(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[843],{

/***/ 73005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ErrorResult; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_tournament_lobby_ticketCreation_ticketCreateModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39030);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41682);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var _ui_empty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29716);
/* harmony import */ var _ui_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66303);
/* harmony import */ var _errorResult_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77306);
/* harmony import */ var _errorResult_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_errorResult_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var ErrorResult = function(param) {
    var className = param.className, _description = param.description, description = _description === void 0 ? "We're as clueless as you are \uD83D\uDE35" : _description, _icon = param.icon, icon = _icon === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_icon__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .J, {
        variant: "closeCircle",
        size: 4
    }) : _icon, _title = param.title, title = _title === void 0 ? "An error has occurred" : _title, hideReportButton = param.hideReportButton, customActions = param.customActions;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_errorResult_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper), className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_empty__WEBPACK_IMPORTED_MODULE_5__/* .Empty */ .H, {
                    icon: icon,
                    title: title,
                    description: description,
                    actions: [
                        !hideReportButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                            variant: "error",
                            onClick: function() {
                                return setOpen(true);
                            },
                            children: "Report this problem"
                        }, "reportButton"),
                        customActions, 
                    ]
                })
            }),
            !hideReportButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tournament_lobby_ticketCreation_ticketCreateModal__WEBPACK_IMPORTED_MODULE_1__/* .TicketCreateModal */ .x, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                }
            })
        ]
    });
};


/***/ }),

/***/ 28865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ editForms; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/results/errorResult.tsx
var errorResult = __webpack_require__(73005);
// EXTERNAL MODULE: ./components/ui/progress/index.tsx + 2 modules
var progress = __webpack_require__(12215);
// EXTERNAL MODULE: ./components/ui/select/index.tsx
var ui_select = __webpack_require__(35049);
// EXTERNAL MODULE: ./generated/graphql.tsx + 18 modules
var graphql = __webpack_require__(93594);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/gameInformationForm.tsx








var GameInformationForm = function(param) {
    var gameModes = param.gameModes, value = param.value, onChange = param.onChange, validate = param.validate;
    var ref, ref1;
    var ref2 = (0,graphql/* useGetGamesQuery */.rt)(), data = ref2.data, loading = ref2.loading, error = ref2.error;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(progress/* ProgressCircle */._, {});
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(errorResult/* ErrorResult */.Z, {});
    var games = (data === null || data === void 0 ? void 0 : data.games) || [];
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* Select */.P, {
                placeholder: "Game",
                options: games.map(function(game) {
                    return {
                        title: game.title,
                        value: game.id,
                        data: game
                    };
                }),
                value: value === null || value === void 0 ? void 0 : (ref = value.game) === null || ref === void 0 ? void 0 : ref.id,
                validate: function() {
                    var ref;
                    return (ref3 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.game) !== null && ref3 !== void 0 ? ref3 : null;
                },
                onChange: function(opt) {
                    return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                        game: opt === null || opt === void 0 ? void 0 : opt.data
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* Select */.P, {
                placeholder: "Game Mode",
                options: gameModes.map(function(gameMode) {
                    return {
                        title: gameMode.title,
                        value: gameMode.id,
                        data: gameMode
                    };
                }),
                value: value === null || value === void 0 ? void 0 : (ref1 = value.gameMode) === null || ref1 === void 0 ? void 0 : ref1.id,
                validate: function() {
                    var ref;
                    return (ref4 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.gameMode) !== null && ref4 !== void 0 ? ref4 : null;
                },
                onChange: function(opt) {
                    return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                        gameMode: opt === null || opt === void 0 ? void 0 : opt.data
                    }));
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/card/index.tsx
var card = __webpack_require__(6457);
// EXTERNAL MODULE: ./components/ui/empty/index.tsx
var empty = __webpack_require__(29716);
// EXTERNAL MODULE: ./components/ui/icon/index.tsx
var icon = __webpack_require__(66303);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/tournament/creation/editForms/editForms.module.scss
var editForms_module = __webpack_require__(88445);
var editForms_module_default = /*#__PURE__*/__webpack_require__.n(editForms_module);
;// CONCATENATED MODULE: ./components/tournament/creation/editForms/editForms.tsx












var EditForms = function(param) {
    var mode = param.mode, formValues = param.formValues, forms = param.forms, onChange = param.onChange, errors = param.errors, className = param.className;
    var addedForms = [
        {
            title: "Game Information",
            name: "gameInformation",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameInformationForm, {
                gameModes: [
                    {
                        id: "1",
                        title: "1 v 1",
                        value: 1
                    }, 
                ]
            })
        }, 
    ];
    if (!((forms === null || forms === void 0 ? void 0 : forms.length) > 0)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* Empty */.H, {
        title: "ERROR",
        description: "One of our devs messed up the form loading",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
            variant: "closeCircle",
            size: 4
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((editForms_module_default()).wrapper, className),
        children: (0,_to_consumable_array/* default */.Z)(addedForms).concat((0,_to_consumable_array/* default */.Z)(forms)).map(function(form, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(card/* Card */.Z, {
                insetTitle: true,
                headerColor: mode === "summary" ? (editForms_module_default()).white : (editForms_module_default()).ashBlack,
                title: form.title,
                className: (editForms_module_default()).card,
                children: /*#__PURE__*/ react.cloneElement(form.form, {
                    value: formValues === null || formValues === void 0 ? void 0 : formValues[form.name],
                    validate: function() {
                        return errors;
                    },
                    onChange: function(value) {
                        return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), (0,_define_property/* default */.Z)({}, form.name, value)));
                    }
                })
            }, index);
        })
    });
};
/* harmony default export */ var editForms = (EditForms);


/***/ }),

/***/ 6457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _card_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(399);
/* harmony import */ var _card_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_card_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var tinycolor2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1547);









var Card = function(_param) {
    var title = _param.title, children = _param.children, insetTitle = _param.insetTitle, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? 5 : _borderRadius, headerColor = _param.headerColor, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "title",
        "children",
        "insetTitle",
        "borderRadius",
        "headerColor",
        "className",
        "disabled"
    ]);
    var headerTextColor = tinycolor2__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mostReadable */ .Z.mostReadable(new tinycolor2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(headerColor), [
        (_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().white),
        (_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().steel)
    ], {
        level: "AAA"
    }).toHexString();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().card), className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().disabled), disabled)),
        style: {
            borderRadius: borderRadius
        }
    }, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().insetTitle), insetTitle)),
                style: insetTitle ? {
                    background: headerColor,
                    color: headerTextColor
                } : {},
                children: title && typeof title === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().titleString),
                    children: title
                }) : title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                children: [
                    " ",
                    children
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 12215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ ProgressCircle; }
});

// UNUSED EXPORTS: ProgressBar

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/ui/progress/progressBar.tsx




var ProgressBar = function(param) {
    var _percent = param.percent, percent = _percent === void 0 ? 0 : _percent, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 0.25 : _strokeWidth, description = param.description, _showDescription = param.showDescription, showDescription = _showDescription === void 0 ? true : _showDescription, fillColor = param.fillColor, backgroundColor = param.backgroundColor, className = param.className;
    return /*#__PURE__*/ _jsxs("div", {
        className: classnames(styles.barWrapper, className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.barBackground,
                style: {
                    height: "".concat(strokeWidth, "rem"),
                    background: fillColor
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.barFill,
                    style: {
                        width: "".concat(100 - (percent > 100 ? 100 : percent < 0 ? 0 : percent), "%"),
                        height: "".concat(strokeWidth, "rem"),
                        background: backgroundColor
                    }
                })
            }),
            showDescription && /*#__PURE__*/ _jsx("span", {
                className: styles.text,
                children: description !== null && description !== void 0 ? description : "".concat(percent, "%")
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/icon/index.tsx
var ui_icon = __webpack_require__(66303);
// EXTERNAL MODULE: ./components/ui/progress/progressCircle.module.scss
var progressCircle_module = __webpack_require__(8169);
var progressCircle_module_default = /*#__PURE__*/__webpack_require__.n(progressCircle_module);
;// CONCATENATED MODULE: ./components/ui/progress/progressCircle.tsx





var ProgressCircle = function(param) {
    var _percent = param.percent, percent = _percent === void 0 ? 0 : _percent, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 0.25 : _strokeWidth, icon = param.icon, progressColor = param.progressColor, backgroundColor = param.backgroundColor, _size = param.size, size = _size === void 0 ? 3 : _size, description = param.description, _descriptionPlacement = param.descriptionPlacement, descriptionPlacement = _descriptionPlacement === void 0 ? "center" : _descriptionPlacement;
    var ref = (0,react.useState)(0), offset = ref[0], setOffset = ref[1];
    size *= 16;
    strokeWidth *= 16;
    var center = size / 2;
    var radius = size / 2 - strokeWidth / 2;
    var circumference = 2 * Math.PI * radius;
    (0,react.useEffect)(function() {
        setOffset((100 - (percent > 100 ? 100 : percent < 0 ? 0 : percent)) / 100 * circumference);
    }, [
        setOffset,
        circumference,
        percent
    ]);
    var _variant, _color, ref1, _size1, _rotate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (progressCircle_module_default()).wrapper,
        style: {
            height: size,
            width: size
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: size,
                height: size,
                fill: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : (progressCircle_module_default()).steel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "gradient",
                            x1: "0%",
                            x2: "0%",
                            y1: "0%",
                            y2: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0%",
                                    stopColor: (progressCircle_module_default()).tertiary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "50%",
                                    stopColor: (progressCircle_module_default()).primary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "100%",
                                    stopColor: (progressCircle_module_default()).secondary
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: center,
                        cy: center,
                        r: radius,
                        strokeWidth: strokeWidth,
                        stroke: (progressCircle_module_default()).mattBlack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: center,
                        cy: center,
                        r: radius,
                        strokeWidth: strokeWidth,
                        strokeDasharray: circumference,
                        stroke: progressColor !== null && progressColor !== void 0 ? progressColor : "url(#gradient)",
                        strokeDashoffset: offset,
                        transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")"),
                        style: {
                            transition: "stroke-dashoffset 0.5s linear"
                        }
                    })
                ]
            }),
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_icon/* Icon */.J, {
                className: (progressCircle_module_default()).icon,
                variant: (_variant = icon.variant) !== null && _variant !== void 0 ? _variant : "people",
                color: (ref1 = (_color = icon.color) !== null && _color !== void 0 ? _color : progressColor) !== null && ref1 !== void 0 ? ref1 : "gradient",
                size: (_size1 = icon.size) !== null && _size1 !== void 0 ? _size1 : size / 32,
                style: {
                    transform: "translate(-50%, -50%) rotate(".concat((_rotate = icon.rotate) !== null && _rotate !== void 0 ? _rotate : 0, "deg)")
                }
            }),
            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((progressCircle_module_default()).text, (progressCircle_module_default())[descriptionPlacement]),
                children: description
            }) : !icon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: classnames_default()((progressCircle_module_default()).text, (progressCircle_module_default()).center),
                style: {
                    fontSize: size / 3 - 2
                },
                children: [
                    percent,
                    "%"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ui/progress/index.tsx




/***/ }),

/***/ 74827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ Radio; },
  "E": function() { return /* reexport */ RadioGroup; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/ui/radio/radio.module.scss
var radio_module = __webpack_require__(70745);
var radio_module_default = /*#__PURE__*/__webpack_require__.n(radio_module);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./components/ui/radio/radioGroup.module.scss
var radioGroup_module = __webpack_require__(27690);
var radioGroup_module_default = /*#__PURE__*/__webpack_require__.n(radioGroup_module);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/ui/radio/radioGroup.tsx









var RadioGroup = function(_param) {
    var children = _param.children, className = _param.className, style = _param.style, name = _param.name, onChecked = _param.onChecked, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "style",
        "name",
        "onChecked"
    ]);
    var ref = (0,react.useState)(), selected = ref[0], setSelected = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()((radioGroup_module_default()).group, className, (0,_define_property/* default */.Z)({}, (radioGroup_module_default()).initial, !selected)),
        style: style
    }, rest), {
        children: children.map(function(child) {
            if (!child) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (radioGroup_module_default()).radio,
                checked: selected === (child === null || child === void 0 ? void 0 : child.props.value)
            }, child === null || child === void 0 ? void 0 : child.props), {
                name: name !== null && name !== void 0 ? name : child === null || child === void 0 ? void 0 : child.props.name,
                onChange: function(e) {
                    setSelected(e.target.value);
                },
                onChecked: onChecked
            }), child === null || child === void 0 ? void 0 : child.props.value);
        })
    }));
};

;// CONCATENATED MODULE: ./components/ui/radio/radio.tsx








var Radio = function(_param) {
    var label = _param.label, children = _param.children, name = _param.name, value = _param.value, checked = _param.checked, className = _param.className, onChecked = _param.onChecked, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "children",
        "name",
        "value",
        "checked",
        "className",
        "onChecked"
    ]);
    var getChildrenAmount = function(children) {
        var allChildren = function(children) {
            return children.flatMap(function(child) {
                if (child.props.children) {
                    return allChildren(child.props.children);
                }
                return child;
            });
        };
        return allChildren(children).length;
    };
    var _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((radio_module_default()).wrapper, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (radio_module_default()).radio,
                onChange: function() {
                    if (value && name) {
                        if (children) {
                            var activeChild = children.find(function(child) {
                                return child.props.checked;
                            });
                            var _name;
                            onChecked === null || onChecked === void 0 ? void 0 : onChecked({
                                name: name,
                                value: value,
                                child: {
                                    name: (_name = activeChild === null || activeChild === void 0 ? void 0 : activeChild.props.name) !== null && _name !== void 0 ? _name : "",
                                    value: activeChild === null || activeChild === void 0 ? void 0 : activeChild.props.value
                                }
                            });
                        } else {
                            onChecked === null || onChecked === void 0 ? void 0 : onChecked({
                                name: name,
                                value: value
                            });
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        type: "radio",
                        name: name,
                        value: value,
                        checked: checked,
                        className: classnames_default()((radio_module_default()).input, (0,_define_property/* default */.Z)({}, (radio_module_default()).checked, checked))
                    }, rest)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (radio_module_default()).input
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (radio_module_default()).label,
                        children: label
                    })
                ]
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (radio_module_default()).childrenContainer,
                style: {
                    height: checked ? "".concat(getChildrenAmount(children) * 1.5, "rem") : 0
                },
                children: checked && /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup, {
                    className: (radio_module_default()).children,
                    style: {
                        height: checked ? "".concat(getChildrenAmount(children) * 1.5, "rem") : 0
                    },
                    name: (_name = children[0].props.name) !== null && _name !== void 0 ? _name : "sub-".concat(name),
                    onChecked: function(child) {
                        return onChecked === null || onChecked === void 0 ? void 0 : onChecked({
                            name: name !== null && name !== void 0 ? name : "",
                            value: value,
                            child: child
                        });
                    },
                    children: children.map(function(child) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, (0,_object_spread/* default */.Z)({}, child.props), child.key);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ui/radio/index.tsx




/***/ }),

/***/ 97431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ DataHandler; }
/* harmony export */ });
/* unused harmony export shouldDataHandle */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_ui_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29166);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62202);
/* harmony import */ var _components_ui_empty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29716);





var ref;
var shouldDataHandle = function(queryResults) {
    return queryResults.some(function(result) {
        return (ref = result.loading || result.error) !== null && ref !== void 0 ? ref : !result.data;
    });
};
var DataHandler = function(param) {
    var loading = param.loading, error = param.error, errorDisplay = param.errorDisplay, noDataDisplay = param.noDataDisplay, dataAvailable = param.dataAvailable, children = param.children;
    if (!dataAvailable && !error || loading && !dataAvailable) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_loader__WEBPACK_IMPORTED_MODULE_2__/* .Loader */ .a, {
            size: 4,
            strokeWidth: 0.375
        });
    }
    if (error) {
        if (errorDisplay) {
            if (typeof errorDisplay === "string") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_empty__WEBPACK_IMPORTED_MODULE_4__/* .Empty */ .H, {
                description: errorDisplay
            });
            return errorDisplay;
        }
        console.error(error);
    }
    if (!dataAvailable) {
        if (!noDataDisplay || typeof noDataDisplay === "string") react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error(noDataDisplay !== null && noDataDisplay !== void 0 ? noDataDisplay : "404. Couldn't fetch data.");
        else return noDataDisplay;
    }
    return children !== null && children !== void 0 ? children : null;
};


/***/ }),

/***/ 36843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "baseCreationValues": function() { return /* binding */ baseCreationValues; },
  "baseForms": function() { return /* binding */ baseForms; },
  "default": function() { return /* binding */ tournament_new; },
  "stageTypeMap": function() { return /* binding */ stageTypeMap; },
  "validateCreationFormsIndividually": function() { return /* binding */ validateCreationFormsIndividually; },
  "validateCreationFormsTogether": function() { return /* binding */ validateCreationFormsTogether; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/ui/input/index.tsx
var input = __webpack_require__(31518);
// EXTERNAL MODULE: ./components/ui/select/index.tsx
var ui_select = __webpack_require__(35049);
// EXTERNAL MODULE: ./generated/graphql.tsx + 18 modules
var graphql = __webpack_require__(93594);
// EXTERNAL MODULE: ./handlers/dataHandler.tsx
var dataHandler = __webpack_require__(97431);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/tournament/creation/creationForms/additionalInformationForm.module.scss
var additionalInformationForm_module = __webpack_require__(23827);
var additionalInformationForm_module_default = /*#__PURE__*/__webpack_require__.n(additionalInformationForm_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/additionalInformationForm.tsx









var AdditionalInformationForm = function(param) {
    var value = param.value, onChange = param.onChange, validate = param.validate;
    var ref, ref1, ref2, ref3, ref4;
    var languageQuery = (0,graphql/* useGetLanguagesQuery */.Yn)({
        onError: console.error
    });
    var regionQuery = (0,graphql/* useGetRegionsQuery */.Uf)({
        onError: console.error
    });
    var _loading, _error, ref5, ref6, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dataHandler/* DataHandler */.E, {
        loading: (_loading = languageQuery.loading) !== null && _loading !== void 0 ? _loading : regionQuery.loading,
        error: (_error = languageQuery.error) !== null && _error !== void 0 ? _error : regionQuery.error,
        dataAvailable: languageQuery.data !== undefined || regionQuery.data !== undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (additionalInformationForm_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* Select */.P, {
                    placeholder: "Region",
                    options: (ref = regionQuery.data) === null || ref === void 0 ? void 0 : ref.regions.map(function(region) {
                        return {
                            title: region.name,
                            value: region.code,
                            data: region
                        };
                    }),
                    value: value === null || value === void 0 ? void 0 : (ref1 = value.region) === null || ref1 === void 0 ? void 0 : ref1.code,
                    validate: function() {
                        var ref;
                        return (ref5 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.region) !== null && ref5 !== void 0 ? ref5 : null;
                    },
                    onChange: function(opt) {
                        return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                            region: opt === null || opt === void 0 ? void 0 : opt.data
                        }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* Select */.P, {
                    placeholder: "Language",
                    options: (ref2 = languageQuery.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.languages) === null || ref3 === void 0 ? void 0 : ref3.map(function(language) {
                        return {
                            title: (ref6 = language === null || language === void 0 ? void 0 : language.name) !== null && ref6 !== void 0 ? ref6 : "",
                            value: (ref7 = language === null || language === void 0 ? void 0 : language.code) !== null && ref7 !== void 0 ? ref7 : "",
                            data: language
                        };
                    }),
                    value: value === null || value === void 0 ? void 0 : (ref4 = value.language) === null || ref4 === void 0 ? void 0 : ref4.code,
                    validate: function() {
                        var ref;
                        return (ref8 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.language) !== null && ref8 !== void 0 ? ref8 : null;
                    },
                    onChange: function(opt) {
                        return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                            language: opt === null || opt === void 0 ? void 0 : opt.data
                        }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                    placeholder: "Link your Tournament Discord",
                    value: value === null || value === void 0 ? void 0 : value.discordSupportLink,
                    validate: function() {
                        var ref;
                        return (ref9 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.discordSupportLink) !== null && ref9 !== void 0 ? ref9 : null;
                    },
                    onChange: function(e) {
                        return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                            discordSupportLink: e.target.value
                        }));
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/tournament/creation/creationForms/generalInformationForm.module.scss
var generalInformationForm_module = __webpack_require__(23885);
var generalInformationForm_module_default = /*#__PURE__*/__webpack_require__.n(generalInformationForm_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/generalInformationForm.tsx









var GeneralInformationForm = function(param) {
    var gameMode = param.gameMode, value = param.value, onChange = param.onChange, validate = param.validate;
    var ref, ref1;
    var calculateTeamsFromPlayers = function(maxPlayers, gameModeMultiplier) {
        var maxPlayersNumber = parseInt(maxPlayers, 10) || 0;
        var maxTeams = Math.ceil(maxPlayersNumber / gameModeMultiplier);
        return maxTeams;
    };
    var calculatePlayersFromTeams = function(maxTeams, gameModeMultiplier) {
        var maxTeamsNumber = parseInt(maxTeams, 10) || 0;
        var maxPlayers = maxTeamsNumber * gameModeMultiplier;
        return maxPlayers;
    };
    var ref2, _value, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (generalInformationForm_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                placeholder: "Tournament Name",
                value: value === null || value === void 0 ? void 0 : value.title,
                validate: function() {
                    var ref;
                    return (ref2 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.title) !== null && ref2 !== void 0 ? ref2 : null;
                },
                onChange: function(e) {
                    return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                        title: (_value = e.target.value) !== null && _value !== void 0 ? _value : ""
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* Select */.P, {
                    placeholder: "Tournament Mode",
                    options: Object.values(graphql/* StageType */.$b).map(function(key) {
                        return {
                            title: stageTypeMap[key],
                            value: key,
                            data: key
                        };
                    }),
                    value: value === null || value === void 0 ? void 0 : value.type,
                    validate: function() {
                        var ref;
                        return (ref3 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.type) !== null && ref3 !== void 0 ? ref3 : null;
                    },
                    onChange: function(opt) {
                        return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                            type: opt === null || opt === void 0 ? void 0 : opt.data
                        }));
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (generalInformationForm_module_default()).calcWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                placeholder: "Max. Players",
                                value: (ref4 = value === null || value === void 0 ? void 0 : value.maxPlayers) !== null && ref4 !== void 0 ? ref4 : "",
                                onChange: function(e) {
                                    var ref;
                                    onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                        maxPlayers: parseInt(e.target.value, 10) || undefined,
                                        maxTeams: calculateTeamsFromPlayers(e.target.value, (ref = gameMode === null || gameMode === void 0 ? void 0 : gameMode.value) !== null && ref !== void 0 ? ref : 1)
                                    }));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (generalInformationForm_module_default()).equals,
                                children: "="
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                placeholder: "Max. Teams",
                                value: (ref5 = value === null || value === void 0 ? void 0 : value.maxTeams) !== null && ref5 !== void 0 ? ref5 : "",
                                onChange: function(e) {
                                    return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                        maxTeams: parseInt(e.target.value, 10) || undefined,
                                        maxPlayers: calculatePlayersFromTeams(e.target.value, (ref6 = gameMode === null || gameMode === void 0 ? void 0 : gameMode.value) !== null && ref6 !== void 0 ? ref6 : 1)
                                    }));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (generalInformationForm_module_default()).equals,
                                children: "="
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "".concat(roundAmountFromParams({
                                    teamAmount: (ref7 = value === null || value === void 0 ? void 0 : value.maxTeams) !== null && ref7 !== void 0 ? ref7 : 0,
                                    type: (ref8 = value === null || value === void 0 ? void 0 : value.type) !== null && ref8 !== void 0 ? ref8 : null
                                }).toString(), " Rounds")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (generalInformationForm_module_default()).errorText,
                        children: (ref9 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.maxPlayers) !== null && ref9 !== void 0 ? ref9 : validate === null || validate === void 0 ? void 0 : (ref1 = validate(value)) === null || ref1 === void 0 ? void 0 : ref1.maxTeams
                    })
                ]
            })
        ]
    });
};
// Remember to also update the function on the server side if you change this
// packages/server/src/api/stage/stage.mutations.ts
var roundAmountFromParams = function(param) {
    var teamAmount = param.teamAmount, type = param.type;
    if (teamAmount === 0) return 0;
    switch(type){
        case graphql/* StageType.Single */.$b.Single:
            return Math.ceil(Math.log2(teamAmount));
        default:
            return 0;
    }
};

// EXTERNAL MODULE: ./components/tournament/creation/creationForms/optionalInformation.module.scss
var optionalInformation_module = __webpack_require__(99796);
var optionalInformation_module_default = /*#__PURE__*/__webpack_require__.n(optionalInformation_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/optionalInformation.tsx






var ref, ref1;
var OptionalInformationForm = function(param) {
    var value = param.value, onChange = param.onChange, validate = param.validate;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: (optionalInformation_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                placeholder: "Streaming Platform Link",
                value: value === null || value === void 0 ? void 0 : value.streamLink,
                validate: function() {
                    var ref1;
                    return (ref = validate === null || validate === void 0 ? void 0 : (ref1 = validate(value)) === null || ref1 === void 0 ? void 0 : ref1.streamLink) !== null && ref !== void 0 ? ref : null;
                },
                onChange: function(e) {
                    return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                        streamLink: e.target.value
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                placeholder: "Total Prize Pool / Prize",
                value: value === null || value === void 0 ? void 0 : value.prizePool,
                validate: function() {
                    var ref;
                    return (ref1 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.prizePool) !== null && ref1 !== void 0 ? ref1 : null;
                },
                onChange: function(e) {
                    return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                        prizePool: e.target.value
                    }));
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./components/ui/checkbox/checkbox.module.scss
var checkbox_module = __webpack_require__(71207);
var checkbox_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_module);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/icon/index.tsx
var icon = __webpack_require__(66303);
;// CONCATENATED MODULE: ./components/ui/checkbox/index.tsx








var Checkbox = function(_param) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, name = _param.name, checked = _param.checked, borderColor = _param.borderColor, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children",
        "name",
        "checked",
        "borderColor"
    ]);
    return (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((checkbox_module_default()).container, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                id: "checkbox ".concat(name),
                name: name,
                type: "checkbox",
                checked: checked
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "checkbox ".concat(name),
                className: (checkbox_module_default()).label,
                style: {
                    borderColor: borderColor
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
                variant: "tick",
                className: (checkbox_module_default()).checkmark
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "checkbox ".concat(name),
                className: (checkbox_module_default()).children,
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/radio/index.tsx + 2 modules
var ui_radio = __webpack_require__(74827);
// EXTERNAL MODULE: ./components/tournament/creation/creationForms/platformForm.module.scss
var platformForm_module = __webpack_require__(82951);
var platformForm_module_default = /*#__PURE__*/__webpack_require__.n(platformForm_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/platformForm.tsx









var PlatformForm = function(param) {
    var value = param.value, onChange = param.onChange, platforms = param.platforms, validate = param.validate;
    var ref, ref1;
    var allSelected = platforms.every(function(v) {
        var ref;
        return (ref = value === null || value === void 0 ? void 0 : value.map(function(v) {
            return v.code;
        })) === null || ref === void 0 ? void 0 : ref.includes(v.code);
    });
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_radio/* RadioGroup */.E, {
                name: "radios",
                onChecked: function(value) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(value.value === "all" ? platforms : []);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_radio/* Radio */.Y, {
                        checked: allSelected,
                        label: "All",
                        value: "all"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_radio/* Radio */.Y, {
                        checked: !allSelected,
                        label: "Choose Specific",
                        value: "specific"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((platformForm_module_default()).platforms, (0,_define_property/* default */.Z)({}, (platformForm_module_default()).disabled, allSelected)),
                children: platforms.map(function(platform) {
                    var ref;
                    var variant = getIconForPlatform(platform.name);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (platformForm_module_default()).checkbox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                            name: platform.name,
                            value: platform.code,
                            checked: (ref = value === null || value === void 0 ? void 0 : value.map(function(p) {
                                return p.code;
                            })) === null || ref === void 0 ? void 0 : ref.includes(platform.code),
                            onChange: function(e) {
                                return onChange === null || onChange === void 0 ? void 0 : onChange(value ? e.target.checked ? (0,_to_consumable_array/* default */.Z)(value).concat([
                                    platform
                                ]) : value.filter(function(p) {
                                    return p.code !== platform.code;
                                }) : []);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    variant === null ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
                                        variant: variant,
                                        className: (platformForm_module_default()).platformIcon
                                    }),
                                    platform.name
                                ]
                            })
                        }, platform.code)
                    }, platform.code);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (platformForm_module_default()).errorText,
                children: (ref2 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.this) !== null && ref2 !== void 0 ? ref2 : validate === null || validate === void 0 ? void 0 : (ref1 = validate(value)) === null || ref1 === void 0 ? void 0 : ref1.platforms
            })
        ]
    });
};
var getIconForPlatform = function(platform) {
    switch(platform.toLowerCase()){
        case "pc":
            return "pc";
        case "switch":
            return "switch";
        case "mobile":
            return "mobile";
        case "playstation":
            return "playstation";
        case "xbox":
            return "xbox";
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./components/ui/button/index.tsx
var ui_button = __webpack_require__(41682);
// EXTERNAL MODULE: ./pages/tournament/new/index.module.scss
var index_module = __webpack_require__(42);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./components/ui/empty/index.tsx
var empty = __webpack_require__(29716);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(37726);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ../../node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(79192);
// EXTERNAL MODULE: ./components/tournament/creation/creationForms/dateTimePicker.module.scss
var dateTimePicker_module = __webpack_require__(98516);
var dateTimePicker_module_default = /*#__PURE__*/__webpack_require__.n(dateTimePicker_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/dateTimePicker.tsx










var DateTimePicker = function(_param) {
    var value = _param.value, onChange = _param.onChange, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange"
    ]);
    var _minDate;
    var minTime = dayjs_min_default()(rest.minDate).isSame(value !== null && value !== void 0 ? value : new Date(), "day") ? (_minDate = rest.minDate) !== null && _minDate !== void 0 ? _minDate : undefined : dayjs_min_default()().set("hour", 0).set("minute", 0).toDate();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), (0,_object_spread/* default */.Z)({
        showTimeSelect: true,
        fixedHeight: true,
        calendarStartDay: 1,
        selected: value,
        timeFormat: "HH:mm",
        timeIntervals: 15,
        timeCaption: "time",
        dateFormat: "dd.MM.yyyy | HH:mm",
        customInput: /*#__PURE__*/ react.createElement(ExampleCustomInput),
        minTime: minTime,
        maxTime: dayjs_min_default()().set("hour", 23).toDate(),
        onChange: function(val) {
            return !Array.isArray(val) && (onChange === null || onChange === void 0 ? void 0 : onChange(val));
        }
    }, rest));
};
var ExampleCustomInput = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var value = param.value, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        "data-cy": "dateTimePicker",
        className: classnames_default()((dateTimePicker_module_default()).picker, (0,_define_property/* default */.Z)({}, (dateTimePicker_module_default()).selected, value)),
        onClick: onClick,
        children: value ? value : "Pick Time & Date"
    });
});
ExampleCustomInput.displayName = "ExampleCustomInput";

// EXTERNAL MODULE: ./components/tournament/creation/creationForms/timetableForm.module.scss
var timetableForm_module = __webpack_require__(22659);
var timetableForm_module_default = /*#__PURE__*/__webpack_require__.n(timetableForm_module);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Checkbox/Checkbox.js + 6 modules
var Checkbox_Checkbox = __webpack_require__(84540);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(52616);
// EXTERNAL MODULE: ../../node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(35469);
// EXTERNAL MODULE: ../../node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(76537);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/timetableForm.tsx











var TimetableForm = function(param) {
    var value = param.value, onChange = param.onChange, validate = param.validate, _maxCheckinDuration = param.maxCheckinDuration, maxCheckinDuration = _maxCheckinDuration === void 0 ? 60 : _maxCheckinDuration;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(0), checkinFrame = ref4[0], setCheckinFrame = ref4[1];
    var ref5 = (0,react.useState)(false), noShowDisabled = ref5[0], setNoShowDisabled = ref5[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        setCheckinFrame((value === null || value === void 0 ? void 0 : value.checkInStart) && (value === null || value === void 0 ? void 0 : value.checkInEnd) ? ((value === null || value === void 0 ? void 0 : (ref = value.checkInEnd) === null || ref === void 0 ? void 0 : ref.getTime()) - (value === null || value === void 0 ? void 0 : (ref1 = value.checkInStart) === null || ref1 === void 0 ? void 0 : ref1.getTime())) / 1000 / 60 : 0);
    }, [
        value === null || value === void 0 ? void 0 : value.checkInEnd,
        value === null || value === void 0 ? void 0 : value.checkInStart,
        setCheckinFrame
    ]);
    (0,react.useEffect)(function() {
        if (checkinFrame > maxCheckinDuration) setCheckinFrame(maxCheckinDuration);
    }, [
        checkinFrame,
        setCheckinFrame,
        maxCheckinDuration
    ]);
    var ref6, ref7, ref8, ref9, ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (timetableForm_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (timetableForm_module_default()).pickers,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "1. Registration"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Starts on Publish"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "2. Check-in start"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimePicker, {
                                            minDate: new Date(),
                                            value: value === null || value === void 0 ? void 0 : value.checkInStart,
                                            onChange: function(val) {
                                                return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                                    checkInStart: val,
                                                    checkInEnd: calculateCheckInEnd(maxCheckinDuration, val, value === null || value === void 0 ? void 0 : value.checkInEnd)
                                                }));
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "3. Check-in end"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimePicker, {
                                            minDate: (ref6 = dayjs_min_default()(value === null || value === void 0 ? void 0 : value.checkInStart).add(15, "minutes").toDate()) !== null && ref6 !== void 0 ? ref6 : new Date(),
                                            maxDate: (ref7 = dayjs_min_default()(value === null || value === void 0 ? void 0 : value.checkInStart).add(maxCheckinDuration, "m").toDate()) !== null && ref7 !== void 0 ? ref7 : null,
                                            value: value === null || value === void 0 ? void 0 : value.checkInEnd,
                                            onChange: function(val) {
                                                return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                                    checkInEnd: calculateCheckInEnd(maxCheckinDuration, value === null || value === void 0 ? void 0 : value.checkInStart, val)
                                                }));
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "4. (planned) start**"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimePicker, {
                                            minDate: (ref8 = value === null || value === void 0 ? void 0 : value.checkInEnd) !== null && ref8 !== void 0 ? ref8 : new Date(),
                                            value: value === null || value === void 0 ? void 0 : value.plannedStart,
                                            onChange: function(val) {
                                                return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                                    plannedStart: val
                                                }));
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (timetableForm_module_default()).interval,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (timetableForm_module_default()).bracket
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (timetableForm_module_default()).bracket
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (timetableForm_module_default()).label,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        contentEditable: true,
                                        disabled: (value === null || value === void 0 ? void 0 : value.checkInStart) === null,
                                        className: (timetableForm_module_default()).labelInput,
                                        value: checkinFrame === 0 ? "" : checkinFrame,
                                        onChange: function(e) {
                                            var frame = Number.parseInt(e.target.value, 10);
                                            if (isNaN(frame)) frame = 0;
                                            setCheckinFrame(frame > maxCheckinDuration ? maxCheckinDuration : Math.ceil(frame));
                                            if (value === null || value === void 0 ? void 0 : value.checkInStart) onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                                checkInEnd: dayjs_min_default()(value === null || value === void 0 ? void 0 : value.checkInStart).add(frame > maxCheckinDuration ? maxCheckinDuration : frame, "m").toDate()
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "min.*"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (timetableForm_module_default()).errorText,
                children: (ref10 = (ref9 = validate === null || validate === void 0 ? void 0 : (ref = validate(value)) === null || ref === void 0 ? void 0 : ref.checkInStart) !== null && ref9 !== void 0 ? ref9 : validate === null || validate === void 0 ? void 0 : (ref1 = validate(value)) === null || ref1 === void 0 ? void 0 : ref1.checkInEnd) !== null && ref10 !== void 0 ? ref10 : validate === null || validate === void 0 ? void 0 : (ref2 = validate(value)) === null || ref2 === void 0 ? void 0 : ref2.plannedStart
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (timetableForm_module_default()).disclaimer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "*the maximum checkin duration is 60 minutes."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "**can be changed later."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (timetableForm_module_default()).timer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        fullWidth: true,
                        defaultValue: 10,
                        variant: "standard",
                        value: value === null || value === void 0 ? void 0 : value.noShow,
                        type: "number",
                        label: "Match Disqualify Timer",
                        disabled: noShowDisabled,
                        InputProps: {
                            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                position: "end",
                                children: "Minutes"
                            }),
                            inputProps: {
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                                min: 0,
                                max: 60
                            }
                        },
                        onChange: function(e) {
                            return onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                noShow: noShowDisabled ? 0 : parseInt(e.target.value, 10)
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        label: "Disable",
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox/* default */.Z, {
                            inputProps: {
                                "aria-label": "controlled"
                            },
                            checked: noShowDisabled,
                            onChange: function(e) {
                                onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                    noShow: e.target.checked ? 0 : 10
                                }));
                                setNoShowDisabled(e.target.checked);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (timetableForm_module_default()).errorText,
                children: validate === null || validate === void 0 ? void 0 : (ref3 = validate(value)) === null || ref3 === void 0 ? void 0 : ref3.noShow
            })
        ]
    });
};
var calculateCheckInEnd = function(maxCheckinDuration, checkInStart, newCheckInEnd) {
    if (checkInStart && dayjs_min_default()(newCheckInEnd).diff(dayjs_min_default()(checkInStart), "m") > maxCheckinDuration) return dayjs_min_default()(checkInStart).add(maxCheckinDuration, "m").toDate();
    if (checkInStart && dayjs_min_default()(newCheckInEnd).diff(dayjs_min_default()(checkInStart), "m") < 0) return checkInStart;
    return newCheckInEnd;
};

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ui/richTextEditor/richTextEditor.module.scss
var richTextEditor_module = __webpack_require__(69616);
var richTextEditor_module_default = /*#__PURE__*/__webpack_require__.n(richTextEditor_module);
// EXTERNAL MODULE: ../../node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/index.js + 5 modules
var ts = __webpack_require__(77140);
;// CONCATENATED MODULE: ./components/ui/richTextEditor/index.tsx







var RichTextEditor = function(_param) {
    var validate = _param.validate, value = _param.value, placeholder = _param.placeholder, defaultValue = _param.defaultValue, onChange = _param.onChange, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "validate",
        "value",
        "placeholder",
        "defaultValue",
        "onChange"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (richTextEditor_module_default()).container
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (richTextEditor_module_default()).input,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ts/* Editor */.M, {
                        inline: true,
                        initialValue: defaultValue,
                        value: value,
                        apiKey: "jgpovojccwm8fmaae5ptgbcuej10wuqbogo2ktdzjn8txpn4",
                        init: {
                            skin: "oxide-dark",
                            placeholder: placeholder,
                            height: 500,
                            menubar: false,
                            automatic_uploads: false,
                            toolbar: "undo redo | formatselect | " + "bold italic | alignleft aligncenter " + "alignright alignjustify | bullist numlist | ",
                            block_formats: "Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3; Heading 4=h4",
                            plugins: "paste",
                            paste_block_drop: true,
                            paste_data_images: false
                        },
                        onEditorChange: function(value) {
                            return onChange === null || onChange === void 0 ? void 0 : onChange(value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (richTextEditor_module_default()).attribution,
                        children: [
                            "POWERED BY",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.tiny.cloud",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "TINY"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (richTextEditor_module_default()).errorText,
                children: validate === null || validate === void 0 ? void 0 : validate(value)
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/tournament/creation/creationForms/descriptionForm.module.scss
var descriptionForm_module = __webpack_require__(22707);
var descriptionForm_module_default = /*#__PURE__*/__webpack_require__.n(descriptionForm_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/descriptionForm.tsx




var descriptionForm_ref;
var DescriptionForm = function(param) {
    var value = param.value, onChange = param.onChange, validate = param.validate;
    var ref1, ref2;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor, {
                placeholder: "Description",
                value: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (descriptionForm_module_default()).errorText,
                children: (descriptionForm_ref = validate === null || validate === void 0 ? void 0 : (ref1 = validate(value)) === null || ref1 === void 0 ? void 0 : ref1.this) !== null && descriptionForm_ref !== void 0 ? descriptionForm_ref : validate === null || validate === void 0 ? void 0 : (ref2 = validate(value)) === null || ref2 === void 0 ? void 0 : ref2.description
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/tournament/creation/creationForms/rulesetForm.module.scss
var rulesetForm_module = __webpack_require__(11733);
var rulesetForm_module_default = /*#__PURE__*/__webpack_require__.n(rulesetForm_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationForms/rulesetForm.tsx




var rulesetForm_ref;
var RulesetForm = function(param) {
    var value = param.value, onChange = param.onChange, validate = param.validate;
    var ref1, ref2;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor, {
                placeholder: "Ruleset",
                value: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (rulesetForm_module_default()).errorText,
                children: (rulesetForm_ref = validate === null || validate === void 0 ? void 0 : (ref1 = validate(value)) === null || ref1 === void 0 ? void 0 : ref1.this) !== null && rulesetForm_ref !== void 0 ? rulesetForm_ref : validate === null || validate === void 0 ? void 0 : (ref2 = validate(value)) === null || ref2 === void 0 ? void 0 : ref2.ruleset
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/tournament/creation/editForms/editForms.tsx + 1 modules
var editForms = __webpack_require__(28865);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 92 modules
var es = __webpack_require__(66634);
// EXTERNAL MODULE: ../shared/validation/index.ts + 4 modules
var validation = __webpack_require__(42503);
;// CONCATENATED MODULE: ../shared/validation/helpers.ts
var convertErrorsToFieldSpecific = function(errors) {
    var converted = {};
    errors.forEach(function(error) {
        var path = error.path, message = error.message;
        var ref;
        var key = (ref = path.split(".").pop()) !== null && ref !== void 0 ? ref : "";
        converted[key] = message;
    });
    return converted;
};
var convertErrorsToFormSpecific = function(errors) {
    return errors.reduce(function(acc, error) {
        acc[error.path] = error.message;
        return acc;
    }, {});
};

// EXTERNAL MODULE: ./components/tournament/creation/itemCard/itemCard.module.scss
var itemCard_module = __webpack_require__(50544);
var itemCard_module_default = /*#__PURE__*/__webpack_require__.n(itemCard_module);
;// CONCATENATED MODULE: ./components/tournament/creation/itemCard/itemCard.tsx





var ItemCard = function(param) {
    var title = param.title, subtitle = param.subtitle, img = param.img, active = param.active, onClick = param.onClick, disabled = param.disabled;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((itemCard_module_default()).card, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (itemCard_module_default()).active, active), (0,_define_property/* default */.Z)(_obj, (itemCard_module_default()).disabled, disabled), _obj)),
        onClick: disabled ? function() {} : onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (itemCard_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (itemCard_module_default()).subtitle,
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (itemCard_module_default()).background,
                style: {
                    backgroundImage: "url(".concat(img, ")"),
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                }
            })
        ]
    });
};
/* harmony default export */ var itemCard = (ItemCard);

// EXTERNAL MODULE: ./components/tournament/creation/cardSelector/cardSelector.module.scss
var cardSelector_module = __webpack_require__(97568);
var cardSelector_module_default = /*#__PURE__*/__webpack_require__.n(cardSelector_module);
;// CONCATENATED MODULE: ./components/tournament/creation/cardSelector/cardSelector.tsx




var _value;
var CardSelector = function(param) {
    var onChange = param.onChange, value = param.value, comparator = param.comparator, options = param.options;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: (cardSelector_module_default()).selector,
        children: options === null || options === void 0 ? void 0 : options.map(function(o) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(itemCard, {
                "data-cy": "card-selector-option",
                title: o.title,
                subtitle: o.subtitle,
                img: o.img,
                active: value !== null && (comparator === null || comparator === void 0 ? void 0 : comparator(value, o.value)),
                disabled: !o.value,
                onClick: function() {
                    return onChange((_value = o.value) !== null && _value !== void 0 ? _value : null);
                }
            }, o.title);
        })
    });
};
/* harmony default export */ var cardSelector = (CardSelector);

// EXTERNAL MODULE: ./components/ui/card/index.tsx
var card = __webpack_require__(6457);
// EXTERNAL MODULE: ./components/tournament/creation/creationFormCard/creationFormCard.module.scss
var creationFormCard_module = __webpack_require__(56241);
var creationFormCard_module_default = /*#__PURE__*/__webpack_require__.n(creationFormCard_module);
;// CONCATENATED MODULE: ./components/tournament/creation/creationFormCard/index.tsx










var CreationFormCard = function(_param) {
    var disabled = _param.disabled, _insetTitle = _param.insetTitle, insetTitle = _insetTitle === void 0 ? true : _insetTitle, _headerColor = _param.headerColor, headerColor = _headerColor === void 0 ? (creationFormCard_module_default()).primary : _headerColor, children = _param.children, onConfirm = _param.onConfirm, onBack = _param.onBack, _hasBack = _param.hasBack, hasBack = _hasBack === void 0 ? true : _hasBack, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "disabled",
        "insetTitle",
        "headerColor",
        "children",
        "onConfirm",
        "onBack",
        "hasBack"
    ]);
    var ref, ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(card/* Card */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (creationFormCard_module_default()).card,
        insetTitle: insetTitle,
        disabled: disabled,
        headerColor: headerColor
    }, rest), {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((creationFormCard_module_default()).buttonRow, (0,_define_property/* default */.Z)({}, (creationFormCard_module_default()).hidden, disabled)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                        className: classnames_default()((0,_define_property/* default */.Z)({}, (creationFormCard_module_default()).hidden, !hasBack)),
                        variant: "secondary",
                        onClick: onBack,
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                        "data-cy": ((ref1 = (ref = rest.title) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.replace(/[^A-Z0-9]/gi, "")) + "Continue",
                        onClick: onConfirm,
                        children: "Continue"
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/tournament/creation/mainForms/mainForms.module.scss
var mainForms_module = __webpack_require__(98340);
var mainForms_module_default = /*#__PURE__*/__webpack_require__.n(mainForms_module);
;// CONCATENATED MODULE: ./components/tournament/creation/mainForms/mainForms.tsx











var MainForms = function(param) {
    var formValues = param.formValues, onChange = param.onChange, onValidSubmit = param.onValidSubmit, forms = param.forms;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), activeForm = ref2[0], setActiveForm = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (mainForms_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mainForms_module_default()).pageIndicator,
                children: "".concat(activeForm + 1, "/").concat(forms === null || forms === void 0 ? void 0 : forms.length)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mainForms_module_default()).forms,
                children: (ref = forms === null || forms === void 0 ? void 0 : forms.filter(function(_, i) {
                    return i >= activeForm;
                })) === null || ref === void 0 ? void 0 : ref.map(function(form, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CreationFormCard, {
                        "data-cy": ((ref = form.title) === null || ref === void 0 ? void 0 : ref.replace(/[^A-Z0-9]/gi, "")) + "Form",
                        title: form.title,
                        disabled: index !== 0,
                        hasBack: activeForm !== 0,
                        onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var result;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            validateCreationFormsIndividually(formValues[form.name], form.name)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        if (result) {
                                            setErrors(result);
                                        } else if (activeForm === (forms === null || forms === void 0 ? void 0 : forms.length) - 1) {
                                            onValidSubmit === null || onValidSubmit === void 0 ? void 0 : onValidSubmit();
                                        } else {
                                            setActiveForm(activeForm + 1);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        onBack: function() {
                            return setActiveForm(activeForm > 0 ? activeForm - 1 : 0);
                        },
                        children: /*#__PURE__*/ react.cloneElement(form.form, {
                            value: formValues === null || formValues === void 0 ? void 0 : formValues[form.name],
                            validate: function() {
                                return errors === null || errors === void 0 ? void 0 : errors[form.name];
                            },
                            onChange: function(value) {
                                setErrors(null);
                                onChange === null || onChange === void 0 ? void 0 : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), (0,_define_property/* default */.Z)({}, form.name, value)));
                            }
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var mainForms = (MainForms);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./hooks/useAuth.ts
var useAuth = __webpack_require__(25487);
// EXTERNAL MODULE: ../../node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(62202);
// EXTERNAL MODULE: ./components/ui/loader/index.tsx
var loader = __webpack_require__(29166);
;// CONCATENATED MODULE: ./pages/tournament/new/index.tsx


































var baseCreationValues = {
    gameInformation: {
        game: null,
        gameMode: null
    },
    generalInformation: {
        title: "",
        maxPlayers: 0,
        maxTeams: 0,
        type: null
    },
    platforms: [],
    additionalInformation: {
        language: null,
        region: null,
        discordSupportLink: ""
    },
    timetable: {
        checkInStart: null,
        checkInEnd: null,
        plannedStart: null,
        noShow: 10
    },
    description: "<p><br></p>",
    ruleset: "<p><br></p>",
    optionalInformation: {
        prizePool: "",
        streamLink: ""
    }
};
var stageTypeMap = {
    SINGLE: "Single Elimination"
};
var new_ref;
var baseForms = function(formValues) {
    var ref1;
    return [
        {
            title: "General Information",
            name: "generalInformation",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralInformationForm, {
                gameMode: (new_ref = formValues === null || formValues === void 0 ? void 0 : (ref1 = formValues.gameInformation) === null || ref1 === void 0 ? void 0 : ref1.gameMode) !== null && new_ref !== void 0 ? new_ref : {
                    id: "1",
                    title: "1 v 1",
                    value: 1
                }
            })
        },
        {
            title: "Platform",
            name: "platforms",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformForm, {
                platforms: [
                    {
                        code: "pc",
                        name: "PC"
                    },
                    {
                        code: "switch",
                        name: "Switch"
                    },
                    {
                        code: "mobile",
                        name: "Mobile"
                    },
                    {
                        code: "xbox",
                        name: "XBOX"
                    },
                    {
                        code: "playstation",
                        name: "PlayStation"
                    }, 
                ]
            })
        },
        {
            title: "Timetable",
            name: "timetable",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimetableForm, {})
        },
        {
            title: "Additional Information",
            name: "additionalInformation",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalInformationForm, {})
        },
        {
            title: "Ruleset",
            name: "ruleset",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(RulesetForm, {})
        },
        {
            title: "Description",
            name: "description",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionForm, {})
        },
        {
            title: "Optional Information",
            name: "optionalInformation",
            form: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionalInformationForm, {})
        }, 
    ];
};
var NewTournamentPage = function() {
    var ref;
    var ref1 = (0,graphql/* useGetGamesQuery */.rt)(), data = ref1.data, loading = ref1.loading, error = ref1.error;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateTournamentMutation */.Le)({
        update: function(cache, param) {
            var createData = param.data;
            var ref, ref1;
            cache.updateQuery({
                query: graphql/* GetTournamentsDocument */.qw,
                variables: {
                    userHasParticipantRoles: [
                        graphql/* ParticipantRoleType.Host */.lj.Host,
                        graphql/* ParticipantRoleType.Admin */.lj.Admin, 
                    ]
                }
            }, function(data) {
                return {
                    tournaments: (data === null || data === void 0 ? void 0 : data.tournaments) ? (0,_to_consumable_array/* default */.Z)(data.tournaments).concat([
                        (ref = createData === null || createData === void 0 ? void 0 : createData.createTournament) !== null && ref !== void 0 ? ref : null
                    ]) : [
                        (ref1 = createData === null || createData === void 0 ? void 0 : createData.createTournament) !== null && ref1 !== void 0 ? ref1 : null
                    ]
                };
            });
        },
        refetchQueries: [
            {
                query: graphql/* RelatedChatRoomsDocument */.MI
            }
        ]
    }), 2), createTournament = ref2[0], ref3 = ref2[1], creationData = ref3.data, creationLoading = ref3.loading;
    var ref4 = (0,react.useState)(undefined), returnTo = ref4[0], setReturnTo = ref4[1];
    var ref5 = (0,react.useState)(baseCreationValues), formValues = ref5[0], setFormValues = ref5[1];
    // Switch default to 0 after testing!
    var ref6 = (0,react.useState)(0), activePage = ref6[0], setActivePage = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), errors = ref7[0], setErrors = ref7[1];
    var auth = (0,useAuth/* useAuth */.a)();
    var user = auth === null || auth === void 0 ? void 0 : auth.user;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setReturnTo(window.location.origin + router.asPath);
    }, [
        router
    ]);
    var onFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, ref, ref1, ref2, ref3, ref4, ref5, _title, _type, _maxPlayers, _noShow;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            validateCreationFormsTogether(formValues)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) {
                            setErrors(result);
                        } else {
                            ;
                            ;
                            createTournament({
                                variables: {
                                    data: {
                                        gameId: (ref4 = (ref = formValues.gameInformation.game) === null || ref === void 0 ? void 0 : ref.id) !== null && ref4 !== void 0 ? ref4 : "",
                                        gameModeId: (ref5 = (ref1 = formValues.gameInformation.gameMode) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref5 !== void 0 ? ref5 : "",
                                        title: (_title = formValues.generalInformation.title) !== null && _title !== void 0 ? _title : "",
                                        description: formValues.description,
                                        type: (_type = formValues.generalInformation.type) !== null && _type !== void 0 ? _type : graphql/* StageType.Single */.$b.Single,
                                        maxPlayers: (_maxPlayers = formValues.generalInformation.maxPlayers) !== null && _maxPlayers !== void 0 ? _maxPlayers : 8,
                                        platforms: formValues.platforms.map(function(platform) {
                                            return platform.code;
                                        }),
                                        region: (ref2 = formValues.additionalInformation.region) === null || ref2 === void 0 ? void 0 : ref2.code,
                                        language: (ref3 = formValues.additionalInformation.language) === null || ref3 === void 0 ? void 0 : ref3.code,
                                        supportLink: formValues.additionalInformation.discordSupportLink,
                                        checkinStart: formValues.timetable.checkInStart,
                                        checkinEnd: formValues.timetable.checkInEnd,
                                        noShow: (_noShow = formValues.timetable.noShow) !== null && _noShow !== void 0 ? _noShow : 0,
                                        date: formValues.timetable.plannedStart,
                                        rules: formValues.ruleset,
                                        streamLink: formValues.optionalInformation.streamLink,
                                        prizePool: formValues.optionalInformation.prizePool
                                    }
                                }
                            }).then(function(value) {
                                var ref;
                                if ((ref = value.data) === null || ref === void 0 ? void 0 : ref.createTournament) {
                                    return router.push("/tournament/".concat(value.data.createTournament.id, "/hub"));
                                }
                            }).catch(function(err) {
                                console.error(err);
                                dist/* toast.error */.Am.error("Error while creating tournament, please contact an administrator.");
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onFormSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var gameModes = [
        {
            id: "1",
            title: "1 v 1",
            value: 1
        }, 
    ];
    (0,react.useEffect)(function() {
        modules/* animateScroll.scrollToTop */.NY.scrollToTop();
    }, [
        activePage
    ]);
    if (auth === null || auth === void 0 ? void 0 : auth.loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* Loader */.a, {});
    var _GRAPHQL_SERVER_URL;
    if (!user || !user.roles.includes("organizer")) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).noAccess,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Just one more step before you can start."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Please log in with Discord before you can create a new tournament."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: "".concat((_GRAPHQL_SERVER_URL = "https://api.etournity.com") !== null && _GRAPHQL_SERVER_URL !== void 0 ? _GRAPHQL_SERVER_URL : "", "/auth/discord?returnTo=").concat(returnTo),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    children: "Log in with Discord"
                })
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* Empty */.H, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
            variant: "closeCircle",
            size: 5
        }),
        title: "Error",
        description: "An error occurred while loading the page."
    });
    var ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).spacer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            passHref: true,
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                "data-cy": "cancel",
                                variant: "secondary",
                                className: (index_module_default()).cancel,
                                children: "Cancel Creation"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Tournament Creation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).spacer
                    })
                ]
            }),
            activePage !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).title,
                children: getPageTitle(activePage, formValues)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((index_module_default()).gameModePage, (0,_define_property/* default */.Z)({}, (index_module_default()).collapsed, activePage !== 0)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-cy": "gameSelect",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "1. Game Selection"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cardSelector, {
                                        value: formValues.gameInformation.game,
                                        options: (0,_to_consumable_array/* default */.Z)(loading ? [] : (ref8 = data === null || data === void 0 ? void 0 : (ref = data.games) === null || ref === void 0 ? void 0 : ref.map(function(game) {
                                            var ref;
                                            return {
                                                title: game.title,
                                                value: game,
                                                img: (ref = game.image) === null || ref === void 0 ? void 0 : ref.url
                                            };
                                        })) !== null && ref8 !== void 0 ? ref8 : []).concat([
                                            {
                                                title: "Other Games",
                                                subtitle: "Coming Soon™"
                                            }, 
                                        ]),
                                        comparator: function(a, b) {
                                            return a && b ? (a === null || a === void 0 ? void 0 : a.id) === (b === null || b === void 0 ? void 0 : b.id) : false;
                                        },
                                        onChange: function(val) {
                                            return setFormValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), {
                                                gameInformation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues.gameInformation), {
                                                    game: val
                                                })
                                            }));
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-cy": "modeSelect",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "2. Mode Selection"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cardSelector, {
                                        value: formValues.gameInformation.gameMode,
                                        options: (0,_to_consumable_array/* default */.Z)(gameModes.map(function(gameMode) {
                                            return {
                                                title: gameMode.title,
                                                value: gameMode
                                            };
                                        })).concat([
                                            {
                                                title: "2 v 2",
                                                subtitle: "Coming Soon"
                                            }, 
                                        ]),
                                        comparator: function(a, b) {
                                            return a && b ? (a === null || a === void 0 ? void 0 : a.id) === (b === null || b === void 0 ? void 0 : b.id) : false;
                                        },
                                        onChange: function(val) {
                                            return setFormValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), {
                                                gameInformation: (ref9 = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues.gameInformation), {
                                                    gameMode: val
                                                })) !== null && ref9 !== void 0 ? ref9 : null
                                            }));
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((index_module_default()).mainPage, (0,_define_property/* default */.Z)({}, (index_module_default()).collapsed, activePage !== 1)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainForms, {
                            formValues: formValues,
                            forms: baseForms(formValues),
                            onChange: setFormValues,
                            onValidSubmit: function() {
                                return setActivePage(2);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((index_module_default()).summary, (0,_define_property/* default */.Z)({}, (index_module_default()).collapsed, activePage !== 2)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editForms/* default */.Z, {
                            mode: "summary",
                            formValues: formValues,
                            forms: baseForms(formValues),
                            errors: errors,
                            onChange: setFormValues
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).spacer
                    }),
                    activePage === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).mainBtnDiv,
                        children: [
                            errors && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (index_module_default()).mainBtnErrorText,
                                children: "Error: Please review your inputs"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                className: (index_module_default()).button,
                                loading: creationLoading,
                                disabled: Boolean(creationData === null || creationData === void 0 ? void 0 : creationData.createTournament),
                                "data-cy": "CreateTournamentButton",
                                onClick: onFormSubmit,
                                children: (creationData === null || creationData === void 0 ? void 0 : creationData.createTournament) ? "Tournament Created" : "Confirm and Create Tournament"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: getPageTitle(activePage + 1, formValues)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).spacer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            "data-cy": "confirm",
                            disabled: !formValues.gameInformation.game || !formValues.gameInformation.gameMode,
                            className: classnames_default()((index_module_default()).button, (0,_define_property/* default */.Z)({}, (index_module_default()).hidden, activePage !== 0)),
                            onClick: function() {
                                return setActivePage(1);
                            },
                            children: "Confirm"
                        })
                    })
                ]
            })
        ]
    });
};
var getSelectString = function(values) {
    var title = "";
    if (values.gameInformation.game) title += values.gameInformation.game.title;
    if (values.gameInformation.gameMode) title += " - ".concat(values.gameInformation.gameMode.title);
    if (values.generalInformation.maxPlayers) title += " - ".concat(values.generalInformation.maxPlayers, " Players");
    if (values.generalInformation.type) title += " - ".concat(stageTypeMap[values.generalInformation.type]);
    return title;
};
var getPageTitle = function(page, values) {
    var selectionString = getSelectString(values);
    switch(page){
        case 1:
            return selectionString;
        case 2:
            return "Summary";
        default:
            return "";
    }
};
var validateCreationFormsIndividually = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(values, name) {
        var errorValidation, errors;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    errorValidation = validation/* createTournamentSchema.client */.ay.client[name];
                    return [
                        4,
                        errorValidation.validate(values, {
                            abortEarly: false,
                            stripUnknown: true
                        }).then(function() {
                            return null;
                        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
                        .catch(function(e) {
                            return e.inner;
                        })
                    ];
                case 1:
                    errors = _state.sent();
                    return [
                        2,
                        errors ? (0,_define_property/* default */.Z)({}, name, convertErrorsToFormSpecific(errors)) : null
                    ];
            }
        });
    });
    return function validateCreationFormsIndividually(values, name) {
        return _ref.apply(this, arguments);
    };
}();
var validateCreationFormsTogether = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
        var errors;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        es/* object */.Ry(validation/* createTournamentSchema.client */.ay.client).validate(values, {
                            abortEarly: false,
                            stripUnknown: true
                        }).then(function() {
                            return null;
                        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
                        .catch(function(e) {
                            return e.inner;
                        })
                    ];
                case 1:
                    errors = _state.sent();
                    return [
                        2,
                        errors ? convertErrorsToFieldSpecific(errors) : null
                    ];
            }
        });
    });
    return function validateCreationFormsTogether(values) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var tournament_new = (NewTournamentPage);


/***/ }),

/***/ 77306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"errorResult_wrapper__pDAP5"};

/***/ }),

/***/ 97568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selector":"cardSelector_selector__UMFfK"};

/***/ }),

/***/ 56241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"creationFormCard_idTarget__Dqlpa","fabulousText":"creationFormCard_fabulousText__lyi_I","rainbow":"creationFormCard_rainbow__YcBfe","errorText":"creationFormCard_errorText__F0m6q","card":"creationFormCard_card__UO6Wt","hidden":"creationFormCard_hidden__dcrzA","buttonRow":"creationFormCard_buttonRow__x6lzV"};

/***/ }),

/***/ 23827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"additionalInformationForm_wrapper__O5OMW"};

/***/ }),

/***/ 98516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"dateTimePicker_idTarget__CDAE5","fabulousText":"dateTimePicker_fabulousText__JIN4R","rainbow":"dateTimePicker_rainbow__0odUF","errorText":"dateTimePicker_errorText__7nmX_","picker":"dateTimePicker_picker__DnuKM","selected":"dateTimePicker_selected__To_Fo"};

/***/ }),

/***/ 22707:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"descriptionForm_idTarget__YlCNW","fabulousText":"descriptionForm_fabulousText__MUn_Y","rainbow":"descriptionForm_rainbow__gd3od","errorText":"descriptionForm_errorText__2aQKh"};

/***/ }),

/***/ 23885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"generalInformationForm_idTarget__MIVEY","fabulousText":"generalInformationForm_fabulousText__mCnn6","rainbow":"generalInformationForm_rainbow__KpneP","errorText":"generalInformationForm_errorText__7DwsA","wrapper":"generalInformationForm_wrapper__R_b55","calcWrapper":"generalInformationForm_calcWrapper__0Yeey","equals":"generalInformationForm_equals__Ti6kT"};

/***/ }),

/***/ 99796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"optionalInformation_wrapper__Gb_db"};

/***/ }),

/***/ 82951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"platformForm_idTarget__mhXV_","fabulousText":"platformForm_fabulousText__aU_p9","rainbow":"platformForm_rainbow__zRw5b","errorText":"platformForm_errorText__FXlpX","platforms":"platformForm_platforms__Ucdgw","disabled":"platformForm_disabled__nLxei","checkbox":"platformForm_checkbox__pszcp","platformIcon":"platformForm_platformIcon__Fb_Kb"};

/***/ }),

/***/ 11733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"rulesetForm_idTarget__Z3Xaq","fabulousText":"rulesetForm_fabulousText__WVjuF","rainbow":"rulesetForm_rainbow__7Dd9h","errorText":"rulesetForm_errorText__CtusE"};

/***/ }),

/***/ 22659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"timetableForm_idTarget__6FYiJ","fabulousText":"timetableForm_fabulousText__v6Ly3","rainbow":"timetableForm_rainbow__e7m0N","errorText":"timetableForm_errorText__9xwRZ","wrapper":"timetableForm_wrapper__Ksof2","pickers":"timetableForm_pickers__cTEBW","interval":"timetableForm_interval__0bXj6","bracket":"timetableForm_bracket__SFRbo","label":"timetableForm_label__C4FDf","labelInput":"timetableForm_labelInput__J_veu","disclaimer":"timetableForm_disclaimer__aLPdu","timer":"timetableForm_timer___dnAt"};

/***/ }),

/***/ 88445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"editForms_idTarget__W03Cu","fabulousText":"editForms_fabulousText__TOL_3","rainbow":"editForms_rainbow__pHGR_","errorText":"editForms_errorText__6Sb5z","wrapper":"editForms_wrapper__z0dnm","card":"editForms_card__kQAW8"};

/***/ }),

/***/ 50544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"itemCard_idTarget__pT6P5","fabulousText":"itemCard_fabulousText__sLqOl","rainbow":"itemCard_rainbow___bK71","errorText":"itemCard_errorText__piraX","card":"itemCard_card__EDP5R","background":"itemCard_background__EhyAc","title":"itemCard_title__Tum6_","subtitle":"itemCard_subtitle__zGLBX","active":"itemCard_active__n8IPG","disabled":"itemCard_disabled__N5DMR"};

/***/ }),

/***/ 98340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"mainForms_idTarget__UwCjY","fabulousText":"mainForms_fabulousText__jPkmi","rainbow":"mainForms_rainbow__vWLwm","errorText":"mainForms_errorText__DYf_W","wrapper":"mainForms_wrapper__9CnfS","pageIndicator":"mainForms_pageIndicator__hdJs9","forms":"mainForms_forms__20j4d"};

/***/ }),

/***/ 399:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"card_idTarget__ZFGQw","fabulousText":"card_fabulousText__5qtke","rainbow":"card_rainbow__w5jl_","errorText":"card_errorText__H4wYo","card":"card_card__DSsTF","title":"card_title__7Pfv9","insetTitle":"card_insetTitle__oFZki","titleString":"card_titleString__xJRky","content":"card_content__nQ6xe","disabled":"card_disabled__F6L0G"};

/***/ }),

/***/ 71207:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"checkbox_idTarget__hMEUI","fabulousText":"checkbox_fabulousText__BHdGj","rainbow":"checkbox_rainbow__LYoqq","errorText":"checkbox_errorText__5HLx5","container":"checkbox_container__AjUMh","label":"checkbox_label__UwRqq","checkmark":"checkbox_checkmark__GT4n1","children":"checkbox_children__ubiZo"};

/***/ }),

/***/ 8169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"progressCircle_idTarget__6SvVD","fabulousText":"progressCircle_fabulousText__cLIjJ","rainbow":"progressCircle_rainbow__rDQXd","errorText":"progressCircle_errorText__hS0Vr","wrapper":"progressCircle_wrapper__n1mw7","text":"progressCircle_text__iNJwc","center":"progressCircle_center__IHgFl","left":"progressCircle_left___3ah6","right":"progressCircle_right__IatmM","top":"progressCircle_top___AJLb","bottom":"progressCircle_bottom___qdtZ","icon":"progressCircle_icon__taAnr"};

/***/ }),

/***/ 70745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"radio_idTarget__yT813","fabulousText":"radio_fabulousText__JJiRJ","rainbow":"radio_rainbow__CrvBH","errorText":"radio_errorText__FKipx","wrapper":"radio_wrapper__lMqqZ","radio":"radio_radio__FgxT0","checked":"radio_checked__lQfY9","input":"radio_input__aQCYg","label":"radio_label___8Axn","childrenContainer":"radio_childrenContainer___7xj3","children":"radio_children__sc94p"};

/***/ }),

/***/ 27690:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"radioGroup_idTarget__Cvpj_","fabulousText":"radioGroup_fabulousText__a09FM","rainbow":"radioGroup_rainbow__FakOL","errorText":"radioGroup_errorText__kw0hz","group":"radioGroup_group__noALV","initial":"radioGroup_initial__TWliD","radio":"radioGroup_radio__UVY7p"};

/***/ }),

/***/ 69616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"richTextEditor_success__wBx7o","successDisabled":"#39711a","error":"richTextEditor_error__KBSDF","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"richTextEditor_idTarget__xOVe1","fabulousText":"richTextEditor_fabulousText__iL_f_","rainbow":"richTextEditor_rainbow__spe3L","errorText":"richTextEditor_errorText__P5jSw","container":"richTextEditor_container__ClxHD","input":"richTextEditor_input__KfTpj","labelWrapper":"richTextEditor_labelWrapper__hVoJb","stroke":"richTextEditor_stroke__PkuNu","pulse":"richTextEditor_pulse__FY9vB","stroke-pulse":"richTextEditor_stroke-pulse__bBOOt","label":"richTextEditor_label__xRlDP","label-pulse":"richTextEditor_label-pulse__7Epud","fullWidth":"richTextEditor_fullWidth__Y8poJ","strokeContainer":"richTextEditor_strokeContainer__uDWTc","hidden":"richTextEditor_hidden__kfUL_","disabled":"richTextEditor_disabled__uoiOT","attribution":"richTextEditor_attribution__vZolI"};

/***/ }),

/***/ 42:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"new_idTarget__dWfIv","fabulousText":"new_fabulousText__8rPJD","rainbow":"new_rainbow__ouHfJ","errorText":"new_errorText__I_uU7","wrapper":"new_wrapper__m2rEL","content":"new_content__oBc3o","header":"new_header__n6vpH","cancel":"new_cancel__93iMI","title":"new_title__jj4VY","gameModePage":"new_gameModePage__hhR3w","collapsed":"new_collapsed__YKu9r","mainPage":"new_mainPage__pZdUy","summary":"new_summary__zmAVt","hidden":"new_hidden__Fs6Gw","spacer":"new_spacer__mSGBJ","footer":"new_footer__MbtXW","button":"new_button__cAOhg","mainBtnDiv":"new_mainBtnDiv__klFU8","mainBtnErrorText":"new_mainBtnErrorText__q8h9o","noAccess":"new_noAccess__9IqYT"};

/***/ })

}]);